import { render, staticRenderFns } from "./emailCancel.vue?vue&type=template&id=72999595&scoped=true"
import script from "./emailCancel.vue?vue&type=script&lang=js"
export * from "./emailCancel.vue?vue&type=script&lang=js"
import style0 from "./emailCancel.vue?vue&type=style&index=0&id=72999595&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72999595",
  null
  
)

export default component.exports